"use client"

import React from "react"
import { FormField, FormItem, FormControl } from "@/components/ui/components"
import { RadioGroup, RadioGroupItem } from "@/components/ui/components"
import type { UseFormReturn } from "react-hook-form"

export default function SubjectSelector(props: {
  showSubject: boolean
  form: UseFormReturn<any>
  formItemClass: string
  formLabelClass: string
  radioButtonStyle: string
  subjectLabel: string
  subjectReclamationValue: string
  subjectReclamationLabel: string
  subjectReturnValue: string
  subjectReturnLabel: string
}) {
  if (!props.showSubject) return null
  return (
    <>
      <div className="mt-6">
        <p className="mb-2 text-lg font-semibold">Ihr Anliegen</p>
      </div>

      <FormField
        control={props.form.control}
        name="ReclamationForm_Subject"
        render={({ field }) => (
          <FormItem className={props.formItemClass}>
            <label className={props.formLabelClass}>
              {props.subjectLabel ?? "Betreff"}
              <span className="ml-1 text-sm text-primary">*</span>
            </label>
            <FormControl>
              <RadioGroup className="flex flex-row flex-wrap gap-4" value={field.value} onValueChange={field.onChange}>
                <div className="flex items-center gap-2">
                  <RadioGroupItem className={props.radioButtonStyle} id="reclamationSubject" value={props.subjectReclamationValue} />
                  <label htmlFor="reclamationSubject">{props.subjectReclamationLabel}</label>
                </div>
                <div className="flex items-center gap-2">
                  <RadioGroupItem className={props.radioButtonStyle} id="returnSubject" value={props.subjectReturnValue} />
                  <label htmlFor="returnSubject">{props.subjectReturnLabel}</label>
                </div>
              </RadioGroup>
            </FormControl>
          </FormItem>
        )}
      />
    </>
  )
}
